// Externe Bibliotheken
import React, { Component } from 'react';
import _ from 'lodash';
import axios from 'axios';

// Interne Module
import * as storage from '@/_helper/storage';
import { convertDate, convertPrice, createPaxAges } from '@/_helper/mapper';
import tracking from '@/_helper/tracking';

// Komponenten
import LoadingOffersBar from '@/comp/loadingOffersBar';
import { BackButton } from '@/comp/backButton/backButton';
import Button from '@/comp/button/button';

const params = {
    title: {
        both: {
            title: 'Roundtrip',
            subline: 'Hin- und Rückfahrt',
        },
        inbound: {
            title: 'Rückfahrt',
            subline: 'einfache Rückfahrt',
        },
        outbound: {
            title: 'Hinfahrt',
            subline: 'einfache Hinfahrt',
        },
    },
    errorWording: {
        railAndFlyOffer: 'Bitte wählen Sie eine Option aus.',
    },
};

class Form extends Component {
    constructor(props) {
        super(props);

        this.state = {
            tabIndex: 0,
            data: [],
            isLoading: false,
            hasResult: false,
            railAndFlyOfferValid: false,
            formErrors: {
                railAndFlyOffer: '',
            },
            error: null,
            formValid: false,
            formVacancy: false,
        };

        this.getOffers = this.getOffers.bind(this);

        this.handleCheckClicked = this.handleCheckClicked.bind(this);

        this.handleUserInput = this.handleUserInput.bind(this);

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        let offers = storage.get('railAndFlyOffers');

        // remove old offers
        if (offers !== null && offers.data !== undefined && offers.data.travelType.indexOf('railAndFly') === -1) {
            storage.remove('railAndFlyOffers');
        } else if (offers !== null) {
            this.setState({
                data: offers.data,
                isLoading: false,
            });

            return false;
        }

        // loading state
        this.setState({ isLoading: true });

        // get offers
        this.getOffers();
    }

    getOffers() {
        let bookingData = storage.get('bookingData');
        let searchParams = undefined;
        if (bookingData !== null) {
            searchParams = bookingData.data.searchParams;
        }
        if (searchParams !== undefined) {
            let $this = this;

            function setData(data) {
                if ($this.state.data.railAndFlyOffers !== undefined && data['railAndFlyOffers'] !== undefined) {
                    data['railAndFlyOffers'] = _.assign($this.state.data.railAndFlyOffers, data.railAndFlyOffers);
                }

                $this.setState({
                    data: data,
                    hasResult: true,
                });

                storage.set('railAndFlyOffers', {
                    data: data,
                });
            }

            function request(sendData) {
                axios({
                    url: window.$requestUrl + '/searchExtra?token=' + window.$token,
                    method: 'POST',
                    data: JSON.stringify(sendData),
                })
                    .then((response) => response)
                    .then((data) => {
                        setData(data.data.data);
                    });
            }

            const sendData = {
                requestType: 'searchExtra',
                travelType: 'railAndFly',
                departureAirportCodes: [searchParams.depAirport],
                regionCode: searchParams.destination,
                arrivalAirportCode: searchParams.retAirport,
                travelStart: convertDate(searchParams.depDate),
                travelEnd: bookingData.data.flightDetailParams
                    ? bookingData.data.flightDetailParams.inboundArrivalDate
                    : convertDate(searchParams.retDate),
                paxAges: createPaxAges(searchParams.paxAges),
                filterTags: [],
                clientId: 'customerarea',
            };
            request(sendData);
        }
    }

    handleUserInput(event) {
        const target = event.target;
        let value = target.value;
        const name = target.name;

        // if ( target.checked ) {
        value = target.checked !== true ? false : true;
        // }

        this.setState({ [name]: target.value }, () => {
            this.validateField(name, value);
        });
    }

    validateField(fieldName, value) {
        let fieldValidationErrors = this.state.formErrors;
        let railAndFlyOfferValid = this.state.railAndFlyOfferValid;

        switch (fieldName) {
            case 'railAndFlyOffer':
                railAndFlyOfferValid = value === true;
                fieldValidationErrors.railAndFlyOffer = railAndFlyOfferValid ? '' : params.errorWording.railAndFlyOffer;
                break;
            default:
                break;
        }
        this.setState(
            { formErrors: fieldValidationErrors, railAndFlyOfferValid: railAndFlyOfferValid },
            this.validateForm
        );
    }

    validateForm() {
        this.setState({ formValid: this.state.railAndFlyOfferValid });
    }

    handleCheckClicked(e) {
        this.setState({
            [e.target.name]: e.target.checked,
        });
    }

    handleSubmit(event) {
        event.preventDefault();

        // form validation
        if (!this.state.formValid) {
            // form is invalid! so we do nothing

            // set error dialogs
            let fieldValidationErrors = this.state.formErrors;
            fieldValidationErrors.railAndFlyOffer = params.errorWording.railAndFlyOffer;

            this.setState({
                formErrors: fieldValidationErrors,
            });

            return;
        }
        // form is valid!

        // Vacancy
        const sendVacancyData = {
            travelType: 'railAndFly',
            vacancyType: 'railAndFly',
            railAndFlyOfferKey: this.state.railAndFlyOffer,
            responseDetailLevel: 'full',
            ignoreCache: true,
            vacancyBeforeBooking: true,
            requestType: 'vacancy',
            clientId: 'customerarea',
            processToken: this.state.data.processToken,
        };

        this.setState({
            formVacancy: true,
        });

        let offerId = this.state.railAndFlyOffer;

        axios({
            url: window.$requestUrl + '/vacancy?token=' + window.$token,
            method: 'POST',
            data: JSON.stringify(sendVacancyData),
        })
            .then((response) => response)
            .then(function (response) {
                let bookStates = {
                    travelType: 'railAndFly',
                    vacancyToken: response.data.data.requestToken,
                    processToken: response.data.data.processToken,
                    offerId: offerId,
                    vacancyData: response.data.data.railAndFlyOffer,
                };
                sessionStorage.setItem('bookStates', JSON.stringify(bookStates));

                window.location.href = `#/buchung/${window.$content.extras['railAndFly'].link}`;
            })
            .catch((error) => this.setState({ error, formVacancy: false }));
    }

    image(direction) {
        let directionIcon = '';

        switch (direction) {
            case (direction = 'both'):
                directionIcon = 'autorenew';
                break;
            case (direction = 'inbound'):
                directionIcon = 'arrow_back';
                break;
            case (direction = 'outbound'):
                directionIcon = 'arrow_forward';
                break;
            default:
        }

        return (
            <div className="image">
                <span className="direction">
                    <i className="material-icons">{directionIcon}</i>
                </span>
                <i className="main material-symbols-outlined">train</i>
            </div>
        );
    }

    description(direction) {
        let directionText = '';
        switch (direction) {
            case (direction = 'both'):
                directionText =
                    'Die Tickets gelten am Tag vor dem Abflugtermin, am Abflugtag selbst, am Tag der Rückreise und am Tag danach.';
                break;
            case (direction = 'inbound'):
                directionText = 'Die Tickets gelten am Tag der Rückreise und am Tag danach.';
                break;
            case (direction = 'outbound'):
                directionText = 'Die Tickets gelten am Tag vor dem Abflugtermin und am Abflugtag selbst. ';
                break;
            default:
        }

        return (
            <div className="description">
                <p>{directionText}</p>
            </div>
        );
    }

    render() {
        const { isLoading, error, hasResult } = this.state;

        if (error || this.state.data === undefined) {
            return (
                <div>
                    <div className="error">{window.$content.errorText}</div>
                    <div className="user-action">
                        <BackButton class="col" target="blank" />
                    </div>
                </div>
            );
        }

        if (isLoading) {
            if (hasResult) {
                setTimeout(() => {
                    this.setState({
                        isLoading: false,
                    });
                }, 2000);
            }
            return <LoadingOffersBar hasResult={hasResult} />;
        }

        // generate tabs
        const entries = [];
        const $offers = [];

        if (this.state.data && this.state.data.railAndFlyOffers !== undefined) {
            let $railAndFlyOffers = this.state.data.railAndFlyOffers;

            // remove already booked offers
            let railAndFlyDirections = [];
            if (storage.get('bookingData') !== null) {
                function logic(value, frontend = false) {
                    _.forEach(value, function (railAndFlyValue) {
                        if (frontend) {
                            if (railAndFlyValue.data?.direction !== undefined) {
                                railAndFlyDirections.push(railAndFlyValue.data.direction);
                            }
                        } else {
                            railAndFlyDirections.push(railAndFlyValue.direction);
                        }
                    });
                }

                // booked service : IBE
                if (storage.get('bookingData').data.serviceInformation?.railAndFly !== null) {
                    logic(storage.get('bookingData').data.serviceInformation?.railAndFly);
                }

                // booked service : frontend
                if (storage.get('bookingData').bookedService !== null) {
                    if (storage.get('bookingData').bookedService?.railAndFly) {
                        logic(storage.get('bookingData').bookedService?.railAndFly, true);
                    }
                }

                if (
                    storage.get('bookingData').data.serviceInformation?.railAndFly !== undefined ||
                    storage.get('bookingData').bookedService !== undefined
                ) {
                    $railAndFlyOffers = _.filter($railAndFlyOffers, function (o) {
                        return railAndFlyDirections.find(
                            (element) => o.direction !== element && o.direction !== 'both'
                        );
                    });
                }
            }

            if ($railAndFlyOffers.length === 0) {
                return (
                    <div>
                        <div className="error offers">{window.$content.errorNoOffersText}</div>
                        <div className="user-action">
                            <BackButton class="col" target="blank" />
                        </div>
                    </div>
                );
            }

            Object.keys($railAndFlyOffers).forEach((k) => {
                const { price, offerKey, direction } = $railAndFlyOffers[k];

                $offers.push(
                    <div key={offerKey} className={'case ' + direction} direction={direction}>
                        <input
                            id={offerKey}
                            type="radio"
                            name={'railAndFlyOffer'}
                            value={offerKey}
                            onChange={(event) => this.handleUserInput(event)}
                        />
                        <div className="icon"></div>
                        <label htmlFor={offerKey}>
                            <div className="head">
                                {this.image(direction)}

                                <div className="content">
                                    <h3 className="title">{params.title[direction].title}</h3>
                                    <h4 className="subline">{params.title[direction].subline}</h4>
                                </div>
                            </div>
                            <div className="inline-content">
                                <div className="cnt">{this.description(direction)}</div>

                                <div className="price-sec">
                                    <small>Gesamtpreis</small>
                                    <div className="overall-price">
                                        {price.overallGrossPrice >= 0 ? '+' : '-'}{' '}
                                        {convertPrice(price.overallGrossPrice, 0, 0)}
                                    </div>
                                </div>
                            </div>
                        </label>
                    </div>
                );
            });

            entries.push(
                <div className="entry" key="">
                    <div className="offers">
                        {$offers}

                        {this.state.railAndFlyOfferValid === false &&
                            this.state.formErrors.railAndFlyOffer.length > 0 && (
                                <div className="error">{this.state.formErrors.railAndFlyOffer}</div>
                            )}
                    </div>

                    <div className="user-action fixed">
                        <BackButton class="col" target="blank" />

                        <Button
                            valid={this.state.formValid}
                            validated={this.state.formVacancy}
                            icon="arrow_forward"
                            type="submit"
                            label={this.state.formVacancy ? 'Daten werden übermittelt ...' : 'Weiter zur Übersicht'}
                        />
                    </div>
                </div>
            );
        }

        return (
            <form
                className={'txtL ' + (this.state.formVacancy ? 'validate' : '')}
                autoComplete="off"
                onSubmit={this.handleSubmit}
                method="post"
                noValidate=""
                onChange={() => tracking('interaction', 'railAndFly')}>
                {entries}
            </form>
        );
    }
}

export default Form;
